import React from 'react'
import QRCode from 'react-qr-code'
import { useSelector } from 'react-redux'
import NoTokenLocationSelected from '../NoTokenLocationSelected'
import '../styles.css'
import { isMobileDevice } from '../../../helpers'
import { RootState } from '../../../state/reducer'
import {Organization} from "../../../api";
import {Card} from "react-bootstrap";

// Define type for organization if not already defined

export const QRCodeDisplay: React.FC = () => {
  const organization: Organization | undefined = useSelector(
    (state: RootState) => state.machineConfig.organization
  )

  const tokenFormURL: string = useSelector(
    (state: RootState) => state.application.tokenFormURL
  )

  const isMobile: RegExpMatchArray = isMobileDevice

  if (!organization) {
    return (
      <div className="token-view mt-5 p-0 mx-auto col-sm-8 col-md-4">
        <NoTokenLocationSelected />
      </div>
    )
  }

  const qrValue = `${tokenFormURL}/${organization.token_machine_location_code}`
  const qrSize = isMobile ? 128 : 256

  return (
    <div className="token-view mx-auto col-sm-8 col-md-4">
      <div className="text-center">
        <h4>PLEASE SCAN THIS QR CODE</h4>
        <h5>To obtain your token</h5>
      </div>
      <div className="qr-wrapper mt-3 text-center">
        <div style={{ width: '100%', maxWidth: qrSize, margin: '0 auto' }}>
          <QRCode
            value={qrValue}
            style={{ width: '100%', height: 'auto' }}
            viewBox={`0 0 256 256`}
            size={qrSize}
          />
        </div>
        <Card className="mt-4  text-white border-0" style={{ backgroundColor: '#1e293b' }}>
          <Card.Body>
            <h5>These Tokens are valid only for</h5>
            <p className="mb-0">
              {organization.name}, {organization.address}, {organization.city}, {organization.state}
            </p>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}
